<template>
<v-container fluid>
    <v-card flat>
      <v-toolbar color="#f0e633" dark extended flat>
        <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
      </v-toolbar>

      <v-card class="mx-auto"
              max-width="1300"
              style="margin-top: -64px;"
              :loading="loading"
              v-if="ridersP"
              
      >

        <v-toolbar flat>
          <v-toolbar-title class="black--text">Mis Riders</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn class="mr-1"
                 dark
                 color="green"
                 @click.stop="openModalSaveOrEditDialog()"
          >
            <v-icon>mdi-plus</v-icon>
            Nuevo Rider
          </v-btn>

        </v-toolbar>


        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
            :loading="loading"
            loading-text="Cargando... Por favor espere"
            :headers="headers"
            :items="ridersP"
            :search="search"
            :footer-props="pagination"
            :header-props="{
              sortByText: 'Ordenar por',
            }"
            class="elevation-1"
          >
          <template v-slot:top>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar.."
                  single-line
                  hide-details
                  class="d-print-none mr-2"
                ></v-text-field>
              </v-toolbar>
            </template> 
            
            <template v-slot:item.attributes.rider.attributes.photoUrl="{ item }">
              <v-img
                v-if="item.attributes.rider.attributes.photoUrl"
                :src="item.attributes.rider.attributes.photoUrl"
                aspect-ratio="1.7"
                class="grey darken-4"
                @click="openImageUrl(item)"
                v-ripple
              ></v-img>
            </template>

            <template v-slot:item.attributes.status="{ item }">
              <v-switch
                v-if="item.attributes.status == 'created'"
                :input-value="item.attributes.status"
                false-value="offline"
                true-value="created"
                color="error"
                inset
                @click.prevent.self="changeStatusRider(item)"
              ></v-switch>
              <v-switch
                v-else
                :input-value="item.attributes.status"
                false-value="offline"
                true-value="online"
                color="success"
                inset
                @click.prevent.self="changeStatusRider(item)"
              ></v-switch>
            </template>
             
            <template v-slot:item.action="{ item }">

            <v-icon class="mr-2" @click="openModalSaveOrEditDialog(true, item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-2" @click="openModalDelete(item)">
              mdi-delete
            </v-icon>  
            <v-icon class="mr-2" @click="openModalPassword(item)">
              mdi-lock
            </v-icon> 
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Recargar</v-btn>
            </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-card>

  <!-- Dialogo delete rider -->
    <v-dialog v-model="isOpenModalDelete" width="600" scrollable persistent>
      <v-card>
        <v-card-title class="title grey lighten-3" primary-title>
          <span class="text-capitalize"> Eliminar Rider </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-img
          max-height="210"
          v-if="storeRider.photoUrl"
          :src="storeRider.photoUrl"
          aspect-ratio="1.7"
          contain
        ></v-img>

        <v-card-text class="d-flex justify-center align-center pa-0 mb-3 mt-2">
          <span class="ma-0">
            ¿ Estás seguro de querer eliminar {{ storeRider.name }} de tú
            lista de Riders ?
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" outlined @click="close()">
            <v-icon left>mdi-close</v-icon> Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="deleteappRider()">
            <v-icon left>mdi-check-bold</v-icon> Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <!-- fin dialogo delete rider -->

  <!-- Dialogo actualizar password rider -->
    <v-dialog v-model="isOpenModalPassword" width="600" scrollable persistent>
      <v-card>
        <v-card-title class="title grey lighten-3" primary-title>
        <span class="text-capitalize"> Editar password de Rider </span>

        <v-spacer></v-spacer>

        </v-card-title>

        <v-divider></v-divider>

        <v-row dense>
          <v-card-text>

            <v-col cols="12" md="6">
                <v-text-field
                  v-model="pin1"
                  :rules="pinRules"
                  outlined
                  type="password"
                  label="Agregue un pin"
                  prepend-inner-icon="mdi-lock"
                  hide-details
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
                <v-text-field
                  v-model="pin2"
                  :rules="pinRules"
                  outlined
                  type="password"
                  label="Agregue un pin"
                  prepend-inner-icon="mdi-lock"
                  hide-details
                ></v-text-field>
            </v-col>
          </v-card-text>
        </v-row>

        <v-divider></v-divider>
        
        <v-card-actions>
          <v-btn color="primary" outlined @click="close()">
            <v-icon left>mdi-close</v-icon> Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="passwordappRider()">
            <v-icon left>mdi-check-bold</v-icon> Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <!-- fin dialogo actualizar password rider -->
  
  <!-- Dialogo Edit Rider -->
    <v-dialog
      v-model="editRiderDialog"
      width="500"
      scrollable
    >
    <v-form ref="formRider" v-model="validEditPromo">
        <v-card>
          <v-card-title class="title grey lighten-3" primary-title>
            <span class="text-capitalize">
              {{ isEdit ? "Editar " : "Nuevo" }} rider
            </span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-img
            max-height="210"
            v-if="storeRider.photoUrl"
            :src="storeRider.photoUrl"
            aspect-ratio="1.7"
            contain
          ></v-img>

          <v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-file-input
                  v-model="attachRiderImage"
                  color="primary accent-4"
                  label="Imagen del Rider"
                  placeholder="Clic aquí para adjuntar"
                  outlined
                  prepend-icon
                  prepend-inner-icon="mdi-paperclip"
                  hide-details
                  :show-size="1000"
                  @change="fileChanged" 
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="primary accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="storeRider.name"
                  :rules="nameRules"
                  outlined
                  label="Nombre"
                  prepend-inner-icon="mdi-account"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="storeRider.phone"
                  :rules="phoneRules"
                  outlined
                  label="Celular"
                  prepend-inner-icon="mdi-phone-classic"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="storeRider.pin"
                  v-if="isEdit != true"
                  :rules="pinRules"
                  outlined
                  label="Agregue un pin"
                  prepend-inner-icon="mdi-lock"
                  hide-details
                ></v-text-field>
              </v-col>

              <!--<v-col cols="12" md="12">
                <v-switch
                  v-model="storeRider.status"
                  inset
                  color="success"
                  false-value="inactive"
                  true-value="active"
                  :label="`Activo`"
                  hide-details
                ></v-switch>
              </v-col>-->

            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" outlined @click="close()">
              <v-icon left>mdi-close</v-icon> Cerrar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" outlined @click="saveOrEditappRider()">
              <v-icon left>mdi-content-save-outline</v-icon> Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>  

      
    <!-- *End* Dialogo Edit Product -->

    

  </v-container>
</template>

<script>
import Parse from "parse";
//import { VueCsvImport } from 'vue-csv-import';

export default {
  components: {},

  data() {
    return {
      ridersP: [],
      loading: true,
      search: "",
      datenow: "",
      storeRider: {
        id: "",
        name: "",
        phone: "",
        pin: "",
        photoUrl: "",
        status: "",
      },
      pin1: "",
      pin2: "",
      isOpenModalPassword: false,
      isOpenModalDelete: false,
      saveOrEditRider: false,
      isEdit: false,
      menu: false,
      validEditPromo: true,
      urlRules: [(v) => !!v || "Url es requerido"],
      nameRules: [(v) => !!v || "El nombre es requerido"],
      phoneRules: [(v) => !!v || "El número de celular es requerido"],
      pinRules: [(v) => !!v || "El pin es requerido"], 
      editRiderDialog: false,

      headers: [
        //{ text: 'ID', align: 'left', value: 'id' },
        { text: 'Nombre', align: "left", value: 'attributes.rider.attributes.name' },
        { text: 'Celular', align: "left", value: 'attributes.rider.attributes.phone' },
        //{ text: 'Pin', align: "left", value: 'attributes.rider.attributes.pin' },
        { text: 'Foto', align: "left", value: 'attributes.rider.attributes.photoUrl' },
        { text: 'Estado', align: "left", value: "attributes.status" },
        { text: 'Acciones', align: "left", value: 'action', sortable: false },    
      ],
 
      pagination: {
        "items-per-page-options": [50, 60, 70, 100, -1],
        "items-per-page-text": "Items por página",
      },
      dialogFilterOrders: false,
      validFilter: false,
      sourceOption: "all",
      attachRiderImage: [],
      frResultAttachRider: "",
    };
  },

  mounted() {
    this.interval = setInterval(this.time, 1000);
    this.initialize();
  },

  destroyed() {
    clearInterval(this.interval);
  },

  computed: {},

  methods: {
    async initialize () {
          let params = {
              store: this.$route.params.store_id
          }
        try {
          let ridersP = await Parse.Cloud.run("listStoreRidersST", params);
          this.ridersP = ridersP
          //eslint-disable-next-line
          //console.log(ridersP);
          this.loading = false
          
        } catch (error) {
          this.$snotify.error(`${error}` , 'Riders', {
            timeout: 4000,
            preventDuplicates: true
          });
        }
        
      },

    time() {
      this.datenow = this.$moment();
    },

    async changeStatusRider(item) {
      try {
        let params = {
          id: item.id,
        };
        this.loading = true;
        await Parse.Cloud.run("changeStatusStoreRiderST", params);
        this.loading = false;
        this.$snotify.success(
          `Se ha cambiado el estado del rider`,
          "Cambio de estado",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
        );
 
      } catch (error) {
        this.$snotify.error(`${error}`, "Rider", {
          timeout: 4000,
          preventDuplicates: true,
        });
      }
      //eslint-disable-next-line
      //console.log(item.id);
    },

    openImageUrl(item) {
      window.open(item.attributes.rider.attributes.photoUrl, "_blank");
    },

    detailBanner(item) {
      //eslint-disable-next-line
      console.log(item);
    },


    openModalSaveOrEditDialog(edit = false, item = ""){
      this.isEdit = edit;
      if(item){
          this.storeRider = {
            id: item.attributes.rider.id,
            name: item.attributes.rider.attributes.name,
            phone: item.attributes.rider.attributes.phone,
            photoUrl: item.attributes.rider.attributes.photoUrl,
            status: item.attributes.status,
          };
      }
      this.attachRiderImage = [];
      this.frResultAttachRider = "";
      this.editRiderDialog=true;
    },
    openModalDelete(item = {}) {
      if (item) {
        this.storeRider = {
          id: item.id,
          name: item.attributes.rider.attributes.name,
          phone: item.attributes.rider.attributes.phone,
          photoUrl: item.attributes.rider.attributes.photoUrl,
          pin: item.attributes.rider.attributes.pin,
          status: item.attributes.status,
        };
      }
      this.isOpenModalDelete = true;
    },

    openModalPassword(item = {}) {
      if (item) {
        this.storeRider = {
          id: item.attributes.rider.id,
          pin: this.pin1,
        };
      }
      this.isOpenModalPassword = true;
    },

    close() {
      this.isOpenModalDelete = false;
      this.editRiderDialog = false;
      this.isEdit = false;
      this.isOpenModalPassword = false;

      this.storeRider = {
        name: "",
        phone: "",
        pin: "",
        photoUrl: "",
        status: "online",
      };
    },

    async saveOrEditappRider() {
      if (!this.$refs.formRider.validate()) {
        this.$snotify.error(
          `Todos los campos son requeridos.`,
          "Rider",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
        );
        return;
      }

      let params = {
        id: this.storeRider.id,
        store: this.$route.params.store_id,
        name: this.storeRider.name,
        phone: this.storeRider.phone,
        pin: this.storeRider.pin,
        photoUrl: this.attachRiderImage
          ? this.attachRiderImage.length == 0
            ? this.storeRider.photoUrl
              ? this.storeRider.photoUrl 
              : ""
            : this.attachRiderImage.type
            ? await this.uploadAttachRiderImage()
            : ""
          : "",
          status: this.storeRider.status,
      };

      if (!params.photoUrl) {
        this.$snotify.error(
          `La imagen del Rider no se ha adjuntado por favor verifica y vuelve a intentarlo`,
          "Rider",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
        );
        return;
      }

      try {
        if (this.isEdit) {
          await Parse.Cloud.run("updateRiderST", params);
          
        } else {
          await Parse.Cloud.run("createRiderST", params);
        }

        //eslint-disable-next-line
        //console.log(params);
        this.$snotify.success(
          `Se ha ${this.isEdit ? "editado" : "guardado"} correctamente.`,
          "Rider",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
        );
        this.close();
        this.initialize();
      } catch (error) {
        this.$snotify.error(`${error}`, "Rider", {
          timeout: 4000,
          preventDuplicates: true,
        });
      }
    },

    async deleteappRider() {
      let params = {
        id: this.storeRider.id,
      };

      try {
        //eslint-disable-next-line
        //console.log(params);
        if (params) {
          await Parse.Cloud.run("deleteStoreRiderST", params);
          this.$snotify.success(
            `Se ha eliminado correctamente.`,
            "Rider",
            {
              timeout: 4000,
              preventDuplicates: true,
            }
          );
        }
        this.close();
        this.initialize();
      } catch (error) {
        this.$snotify.error(`${error}`, "Rider", {
          timeout: 4000,
          preventDuplicates: true,
        });
      }
    },

    async passwordappRider() {
      let params = {
        id: this.storeRider.id,
        pin: this.pin1,
      };
      try {
        if (this.pin1 == this.pin2) {
          await Parse.Cloud.run("updatePasswordRiderST", params);
          this.$snotify.success(
            `Se ha "editado" el password correctamente.`,
            "Rider",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
          );

          this.close();
          this.initialize();

          } else {
            this.$snotify.error(`No coinciden los pines`, "Rider", {
            timeout: 4000,
            preventDuplicates: true,
        });
          }
         
      } catch (error) {
        this.$snotify.error(`${error}`, "Rider", {
          timeout: 4000,
          preventDuplicates: true,
        });
      }
    },

    async uploadAttachRiderImage() {
      let simge = this.frResultAttachRider.split(",");
      simge = simge[1];
      var parseFile = new Parse.File(
        "paymentOrder",
        { base64: simge },
        this.attachRiderImage.type
      );
      let file = await parseFile.save(null);
      return file._url;
    },

    

    fileChanged(file) {
      if (file) {
        const fr = new FileReader();
        if (file) {
          fr.readAsDataURL(file);
          fr.addEventListener("load", () => {
            //eslint-disable-next-line
            //console.log(fr.result);
            this.frResultAttachRider = fr.result;
          });
        }
      }
    },


  },
};
</script>

